<style lang="less">
</style>

<template>
  <div class="doc-wrapper container">
    <left-menu
      :items="items"
      :menus="menus"
      :level-first="levelNameFirst"
      :level-second="levelSecond"
      :active-index="secondActive"
      :third-active="thirdActive"
      :current-menu="currentMenu"
      @on-active-second="handleSetActiveAPI"
      @on-active-third="handleSetThirdActive">
    </left-menu>
    <doc-content :api-detail="apiDetail" :breadcrumb="breadcrumb" :current-path="currentPath"></doc-content>
  </div>
</template>

<script>
  import leftMenu from '@/components/left-menu'
  import docContent from '@/components/doc-content'
  export default {
    name: "page-api",
    data () {
      return {
        menuList: [],
        currentMenu: {},
        firstActive: 0,
        secondActive: 0,
        thirdActive: 0,
        apiDetail: {}
      }
    },
    computed: {
      items () {
        let result = []
        if (this.currentMenu.children) {
          let arr = this.currentMenu.children[this.secondActive]['children']
          if (Array.isArray(arr)) {
            arr.forEach((item) => {
              result.push({
                name: item.name,
                path: item.path,
                method: item.method
              })
            })
          }
        }
        return result
      },
      menus () {
        let result = []
        let arr = this.menuList
        if (Array.isArray(arr)) {
          arr.forEach((v, k) => {
            let obj = {
              name: v.name,
              path: v.path,
              children: []
            }
            if (Array.isArray(v.children)) {
              v.children.forEach((item, key) => {
                obj.children.push({
                  name: item.name,
                  path: item.path
                })
              })
            }
            result.push(obj)
          })
        }
        return result
      },
      levelNameFirst () {
        return this.currentMenu.name
      },
      levelSecond () {
        if (Array.isArray(this.currentMenu.children) && this.currentMenu.children.length > 0) {
          return this.currentMenu.children[this.secondActive]['name']
        } else {
          return ''
        }
      },
      breadcrumb () {
        if (this.menuList.length === 0) {
          return []
        }
        if (this.thirdActive === -1) {
          return
        }
        let firstName = this.menuList[this.firstActive]['name']
        let secondName = this.menuList[this.firstActive]['children'][this.secondActive]['name']
        let thirdName = this.menuList[this.firstActive]['children'][this.secondActive]['children'] ? 
          this.menuList[this.firstActive]['children'][this.secondActive]['children'][this.thirdActive]['name'] :
          this.menuList[this.firstActive]['children'][this.secondActive]['name']
        return [firstName, secondName, thirdName]
      },
      currentPath () {
        if (this.menuList.length === 0) {
          return ''
        }
        if (this.thirdActive === -1) {
          return
        }
        return this.menuList[this.firstActive]['children'][this.secondActive]['children'] ? 
          this.menuList[this.firstActive]['children'][this.secondActive]['children'][this.thirdActive]['path'] :
          this.menuList[this.firstActive]['children'][this.secondActive]['path']
      }
    },
    methods: {
      handleGetMenu () {
        this.$http.get('/api/list').then((res) => {
          if (res.status === 1) {
            this.menuList = res.data.menu.children
            this.currentMenu = this.menuList[this.firstActive]
            this.handleFetchApiDetail()
          }
        })
      },
      handleFetchApiDetail (value) {
        let obj;
        if (value) {
          obj = value.item
          console.log(obj)
        } else {
          if (typeof this.menuList[this.firstActive]['children'][this.secondActive]['children'] !== 'undefined' && typeof this.menuList[this.firstActive]['children'][this.secondActive]['children'][this.thirdActive] !== 'undefined') {
            obj = this.menuList[this.firstActive]['children'][this.secondActive]['children'][this.thirdActive]
          } else {
            obj = this.menuList[this.firstActive]['children'][this.secondActive]
          }
        }
        if (!obj) {
          return
        }
        let params = new FormData()
        params.append('path', obj.path)
        console.log(obj, params)
        this.$http.post('/api/detail', params).then((res) => {
          if (res.status === 1) {
            this.apiDetail = res.data
          }
        })
      },
      handleSetActiveAPI (data) {
        let firstIndex = data.key
        let secondIndex = data.index
        // if (this.menuList[firstIndex]['children'][secondIndex]['children']['length'] > 0) {
          if (this.firstActive !== firstIndex) {
            this.firstActive = firstIndex
            this.currentMenu = this.menuList[firstIndex]
          }
          this.secondActive = secondIndex
          this.thirdActive = 0
          this.handleFetchApiDetail()
        // } else {
          // this.$Message.warning("内容为空")
        // }
      },
      handleSetThirdActive (data) {
        this.thirdActive = data.index
        if (data.type && data.type == 'search') {
          this.thirdActive = -1
          this.handleFetchApiDetail(data)
        } else {
          this.handleFetchApiDetail()
        }
      },
      initData () {
        this.handleGetMenu()
      }
    },
    created () {
      this.initData()
    },
    components: {
      leftMenu,
      docContent
    }
  }
</script>
